import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import Card from "../../../components/Cards/Card";
import NativeObject from "../../../components/NativeObject/NativeObject";

const OBJECT_IDS = {
  COBERTURA_BASE_TABLE: "5c50a841-ae1e-476d-a4e0-40fb0bf7f1d1",
};

const PerformanceCard = ({ app, objectId }) => {
  return (
    <Grid container className="container-cards-kpi">
      <Card app={app} className={"card-kpi-item"} header={{ hardTitle: "Ranking por Cidade" }}>
        <NativeObject
          app={app}
          key={objectId || OBJECT_IDS.COBERTURA_BASE_TABLE}
          style={{ width: "100%", height: "55vh" }}
          reference={{ id: objectId || OBJECT_IDS.COBERTURA_BASE_TABLE }}
          className={"table-item-ranking"}
        />
      </Card>
    </Grid>
  );
};

PerformanceCard.propTypes = {
  app: PropTypes.object.isRequired,
  objectId: PropTypes.string,
};

export default PerformanceCard;
